// extracted by mini-css-extract-plugin
module.exports = {"fab-home-box":"fab-home_fab-home-box__34Xde","fab-home":"fab-home_fab-home__37t44","fab-home-text":"fab-home_fab-home-text__1-7JN"};